module.exports = __webpack_public_path__ + "img/achievement1.fe71364b.jpeg";